/**
 * AliasCard Component
 * 
 * Displays a single alias for review with merge/separate/skip actions.
 */

import React from 'react';
import { Check, Loader, SkipForward, Unlink } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

export default function AliasCard({
  item,
  isProcessing,
  onReview
}) {
  return (
    <div
      style={{
        padding: '16px 18px',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        opacity: isProcessing ? 0.6 : 1,
        transition: 'all 0.2s ease'
      }}
    >
      <p style={{
        margin: '0 0 12px 0',
        fontSize: '15px',
        color: ABLE_COLORS.textPrimary,
        lineHeight: '1.5'
      }}>
        Is "<strong>{item.mention}</strong>" the same as{' '}
        <strong style={{ color: ABLE_COLORS.primary }}>{item.entityName}</strong>?
      </p>

      {item.context && (
        <p style={{
          margin: '0 0 14px 0',
          padding: '10px 14px',
          background: ABLE_COLORS.bgSubtle,
          borderRadius: '10px',
          fontSize: '13px',
          color: ABLE_COLORS.textSecondary,
          fontStyle: 'italic',
          lineHeight: '1.5'
        }}>
          "{item.context}"
        </p>
      )}

      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={() => onReview(item.id, 'skip')}
          disabled={isProcessing}
          style={{
            padding: '10px 14px',
            background: 'white',
            border: `1.5px solid ${ABLE_COLORS.border}`,
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isProcessing ? 'wait' : 'pointer',
            color: ABLE_COLORS.textMuted
          }}
        >
          <SkipForward size={16} />
        </button>
        <button
          onClick={() => onReview(item.id, 'separate')}
          disabled={isProcessing}
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            padding: '10px 16px',
            background: 'white',
            border: `1.5px solid ${ABLE_COLORS.border}`,
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isProcessing ? 'wait' : 'pointer',
            color: ABLE_COLORS.textSecondary
          }}
        >
          <Unlink size={16} />
          Different
        </button>
        <button
          onClick={() => onReview(item.id, 'merge')}
          disabled={isProcessing}
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            padding: '10px 16px',
            background: ABLE_COLORS.primary,
            border: 'none',
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isProcessing ? 'wait' : 'pointer',
            color: 'white'
          }}
        >
          {isProcessing ? <Loader size={16} className="spin" /> : <Check size={16} />}
          Same
        </button>
      </div>
    </div>
  );
}
